module.exports = __webpack_public_path__ + "img/logout-icon.4ceb407e.svg";